/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let customer = {}

customer.getEditDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Customer/GetEditDto',{}, {
    ID: _ID //租户ID
  })
}

customer.add = {
  data: {
    FileList: [],
    // ID: 0, //新增不传
    Name: '',
    BusinessLicense: '',
    IDNum: '',
    TouchMan: '',
    Sex: '',
    Phone: '',
    Email: '',
    QQ: '',
    Wechat: '',
    Address: '',
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Customer/Add', _data)
  }
}

// 修改用户
customer.edit = {
  data: {
    FileList: [],
    ID: 0,
    Name: '',
    BusinessLicense: '',
    IDNum: '',
    TouchMan: '',
    Sex: '',
    Phone: '',
    Email: '',
    QQ: '',
    Wechat: '',
    Address: '',
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Customer/Edit', _data)
  }
}

// 删除
customer.del = (_ID) => {
  return axios('post', config.API_URL + '/api/Customer/Del',{}, {
    idList: _ID
  })
}

// 获取租户列表
customer.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Customer/GetList', _data)
  }
}

customer.export = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Customer/ExportList',_data,{},1)
  }
}
// 末尾传个参数，就是blob类型，具体查询api/index.js中的axios函数

export default customer



